import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';
import { Session } from '@/types/session.types';

const saveWorkingProjectSessionByFieldReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer(
    (
      state,
      action: PayloadAction<Partial<Session> & { uuid: string; saveId?: string; refetchProjectAfterSave?: boolean }>
    ) => {
      const { saveId, refetchProjectAfterSave, ...sessionData } = action.payload;
      // These updates trigger in a debounce inside of save-session-middleware.ts
      state.savingWorkingProject = true;
      state.refetchProjectAfterSave = !!refetchProjectAfterSave;
      state.saveId = saveId ?? state.saveId;
      if (state.workingProject?.sessions) {
        state.updatedSessionUuid = sessionData.uuid;
        state.workingProject.sessions = state.workingProject.sessions.map((s) => {
          if (s.uuid === sessionData.uuid) {
            return {
              ...s,
              ...sessionData,
            };
          }
          return s;
        });
        // Also update working session if it's the same session
        if (sessionData.uuid === state.workingSession?.uuid) {
          state.workingSession = {
            ...state.workingSession,
            ...sessionData,
          };
        }
      }
    }
  );
};

export default saveWorkingProjectSessionByFieldReducer;
